import Moment from "react-moment";

export default function DateDisplay({ startDate, endDate }: any) {
  return (
    <div className="flex items-center">
      <div className="">
        {startDate === "19700101" ? null : (
          <span className="font-bold text-gray-600">
            <Moment format="Do MMM YYYY">{startDate}</Moment>
          </span>
        )}
        {startDate === endDate ? null : (
          <>
            <span className="mx-2">-</span>
            <span className="font-bold text-gray-600">
              <Moment format="Do MMM YYYY">{endDate}</Moment>
            </span>
          </>
        )}
      </div>
    </div>
  );
}
